import { Menu } from "../../model/menudesign/Menu";

const apiUrl = process.env.REACT_APP_API_URL;
export const GetMenusByWeek = async ( page : string, setmana: string ) => {
    try {
        const response = await fetch(`${apiUrl}:8072/menus/${setmana}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            }
        });
        const jsonData = await response.json();
        return jsonData.menus as Menu[];
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};